import { inject, Injectable, signal } from '@angular/core';
import { BaseHttpService } from './base.service';
import { toSignal } from '@angular/core/rxjs-interop';
import { IPrimeNgFilterRequest, ITableResponse } from '@olymp/shared';
import { DIRECTORY_API_URL, IDirectory } from '../constants/directory';
import { map } from 'rxjs';
import { BasePublicHttpService } from './base.public.service';

@Injectable()
export class GetLocationService {
  districts = signal<
    {
      label: string;
      value: number;
    }[]
  >([]);

  institutions = signal<IDirectory[]>([]);

  tableData: IPrimeNgFilterRequest = {
    first: 0,
    rows: 1000,
    filters: '{}',
    sortOrder: 0,
  };

  $baseHttpService = inject(BaseHttpService);
  $basePublicHttpService = inject(BasePublicHttpService);

  regions$ = toSignal(
    this.$baseHttpService
      .post<ITableResponse<IDirectory>>(
        DIRECTORY_API_URL.Regions + '/get-paged',
        this.tableData,
      )
      .pipe(
        map((response) => {
          return response.result.items;
        }),
      ),
  );

  getDistricts(regionId?: number) {
    this.$baseHttpService
      .get<{
        result: {
          label: string;
          value: number;
        }[];
      }>(DIRECTORY_API_URL.Districts + '/select-items/' + regionId)
      .subscribe((res) => {
        this.districts.set(res.result);
      });
  }

  getInsitutions(districtId?: number) {
    const filter = { ...this.tableData };
    filter.filters = JSON.stringify({
      districtId: {
        value: districtId,
      },
    });
    this.$baseHttpService
      .post<ITableResponse<IDirectory>>(
        DIRECTORY_API_URL.Institutions + '/get-paged',
        filter,
      )
      .subscribe((res) => {
        this.institutions.set(res.result.items);
      });
  }
}
